import { useDispatch } from "react-redux";


export type AppModel = {

};

export const models: AppModel = {

};

export const useRematchDispatch = <D extends {}, MD>(selector: (dispatch: D) => MD) => {
	const dispatch = useDispatch<D>();
	return selector(dispatch);
};
